import axios from 'axios';

export const getSearch = async (value: string) => {
    const url = `${process.env.REACT_APP_URL_PROPIEDADES}/properties/direction`;
    const data = {
        term: value,
        state_id: 1,
    };
    const formData = new FormData();
    for (const key in data) {
        formData.append(key, value);
    }
    const res = await axios.post(url, formData, { headers: { cucu: '1' } });
    return res.data || [];
};
